import { createFilterAtoms } from '@/common/filtering/store.ts';
import {
  DEFAULT_LIFT_FILTER,
  type LiftFilterDefinition,
} from '@pac/filter/shared/lifts';
import { resetLiftPaginationOnFilterChangeAtom } from './pagination.ts';

export const liftFilterAtoms = createFilterAtoms<LiftFilterDefinition>(
  DEFAULT_LIFT_FILTER,
  resetLiftPaginationOnFilterChangeAtom,
);
